module.exports = "<screen-container class=screen-container></screen-container> <transition-container></transition-container> <modal-window></modal-window> <div class=app-background></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app.html
 ** module id = 60
 ** module chunks = 0
 **/